module.exports = __webpack_public_path__ + "static/media/win.74b7bd77.png";